.header {
	height: 90px;
	display: flex;
	flex-direction: column;
	flex: 1 1 auto;
}

.top-section {
	height: 50px;
	background-color: var(--ds-background-neutral, var(--adg3-color-N20));
	border-bottom: 1px solid var(--ds-border, var(--adg3-color-N50));
	box-sizing: border-box;
}

.options {
	padding-right: 8px;

	& div[tabindex] {
		padding: 4px 0;

		&:focus {
			outline: none;
		}
	}

	& div[data-role='droplistContent'] {
		/* Without this a scroll bar will appear when there are no fields matched by the filter */
		min-height: 94px;

		/* This ensures that all fields will be displayed without the need for a scrollbar */
		max-height: 500px;
	}
}

.column-header-section {
	display: flex;
	height: 40px;
}

.column-header {
	flex: 1 0;
	display: flex;
	box-sizing: border-box;
	overflow: hidden;
}

.header-spinner {
	margin-right: 5px;
}

.no-fields-header {
	padding: 0 var(--jpo-common-base-spacing);
	align-items: center;
}

.no-fields-text {
	color: var(--ds-text-subtle, var(--adg3-color-N500));
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;
}

.no-focus {
	cursor: default;
	outline: none;
}

.no-focus-collapsible {
	cursor: pointer;
	outline: none;
}

.field-title-wrapper {
	padding: 0 calc(1.5 * var(--jpo-common-base-spacing));
	flex: 1;
	min-width: 0;
	height: 100%;
	display: flex;
	align-items: center;
}

.field-title-wrapper-collapsible {
	padding: 0 calc(1.5 * var(--jpo-common-base-spacing));
	flex: 1;
	min-width: 0;
	height: 100%;
	display: flex;
	align-items: center;

	&:hover {
		background-color: var(--ds-background-neutral, var(--adg3-color-N30));
		/**
         * when hovered over far right side, 
         * bg here goes grey, then sort-trigger will expand, and this element will lose hover
         * Causing a flickering effect, a 1ms delay will fix this 
         */
		-webkit-transition: background-color 1ms;
		transition: background-color 1ms;
	}
}

.field-title {
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
}

.column-header:hover .sortTriggerButton {
	display: flex;
}

.field-icon > span {
	margin-right: 0.5em;
}

.field-icon__left {
	left: 8px;
	position: absolute;
}
